import { Component, OnInit, ViewChild, ElementRef, Input, Output, TemplateRef, Pipe, PipeTransform } from '@angular/core';
import { MdSnackBar } from '@angular/material';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import { FormBuilder, FormGroup, FormControl, AbstractControl, Validators } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/operator/map';
import { Subject } from 'rxjs/Subject';
import { ToasterService } from 'angular2-toaster';
import swal from 'sweetalert2';
import * as _ from 'lodash';
import * as moment from 'moment';

import { CashReceiptService, CommonService, SubscribeService, ChallanOutService } from '../../../services/index';
import { CashReceiptModel, ClientModel, EmployeeModel } from '../../../model/index';

@Component({
    selector: 'addeditcashreceipt-tab',
    templateUrl: './addEditCashReceipt.component.html',
})
export class AddEditCashReceiptComponent implements OnInit {
    private searchTerms = new Subject<string>();
    private searchTermsEmp = new Subject<string>();

    @Input('tabTitle') title: string;
    @Input() active = false;
    @Input() isCloseable = false;
    @Input() dataContext;
    _params: any[] = [];
    @Input() set params(val: any[]) {
        this._params = val;
        this.setPageData();
    }

    public mode: string;
    public list: any[] = [];
    //public salesbilltypesdata: any[] = [];

    isLoadMask: Promise<any>;
    //salesbilltypesData: SalesBillentryModel[];
    isLoading: boolean = false;
    minDate: any;
    filteredSrc: Observable<any[]>;

    @Input() salesBillgriddata: CashReceiptModel[] = [];
    @Input() cashreceipt: CashReceiptModel[] = [];
    potCusCtrl: FormControl;
    halistCtrl: FormControl;
    srclistCtrl: FormControl;
    serialNoCtrl: FormControl;
    filteredHa: Observable<any[]>;
    filteredSerialNo: Observable<any[]>;
    clientCtrl: FormControl;
    filteredItems: Observable<any[]>;

    @ViewChild('halistAutoComp') halistAutoComp;
    @ViewChild('clientAutoComp') clientAutoComp;
    @ViewChild('snoTemplate') snoTemplate: TemplateRef<any>;
    @ViewChild('editDeleteTemplate') editDeleteTemplate: TemplateRef<any>;

    potCusOptList: any[];
    haList: any[] = [];
    clientList: any[] = [];
    srcList: any[] = [];
    serialNoList: any[] = [];
    reorderable: boolean = true;
    page = {
        limit: 20,
        count: 0,
        offset: 0,
        orderBy: 'voucher_no',
        orderDir: 'asc'
    };
    columns = [];
    cashReceiptDetails = [];
    totalDetails = [];
    actSerialNoList = [];
    cliCtrl: FormControl;
    filteredEmp: Observable<any[]>;
    @ViewChild('emplistAutoComp') emplistAutoComp;
    empList: any[] = [];
    clientHVList: any[] = [];
    constructor(private modalService: BsModalService, private cashReceiptService: CashReceiptService, private commonService: CommonService, public snackBar: MdSnackBar, public toasterService: ToasterService, public subscribeService: SubscribeService, private challanoutService: ChallanOutService) {

        //this.halistCtrl = new FormControl();
        //FOR AUTO COMPLETE VALIDATION --- HA MODEL
        function hasValidHaModel(input: FormControl) {
            let ModelID = input.value, retVal = null;
            if (ModelID == "") {
                retVal = { inValidHaModel: true };
            }
            if (ModelID && typeof ModelID === 'string') {
                retVal = { inValidHaModel: true };
            }
            return retVal;
        }
        this.halistCtrl = new FormControl('', [
            Validators.required,
            hasValidHaModel.bind(this)
        ]);
        /*     this.filteredHa = this.halistCtrl.valueChanges
                 .startWith(null)
                 .map(name => name ? this.filterHa(name) : this.haList.slice());*/

        this.serialNoCtrl = new FormControl();
        this.filteredSerialNo = this.serialNoCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterSerialNo(name) : this.serialNoList.slice());

     //FOR AUTO COMPLETE VALIDATION --- BRAND MODEL
        function hasValidType(input: FormControl) {
            let ledgerID = input.value, retVal = null;
            if (ledgerID != "CASH" && ledgerID != "CARD" && ledgerID != "CHEQUE" 
                && ledgerID != "NEFT") {
                retVal = { inValidType: true };
            }
          
            return retVal;
        }
        this.potCusCtrl = new FormControl('', [
            Validators.required,
            hasValidType.bind(this)
        ]);
    
        this.potCusOptList = ['CASH', 'CARD', 'CHEQUE', 'NEFT'];
        this.clientCtrl = new FormControl();
        this.cliCtrl = new FormControl();

         function hasSrc(input: FormControl) {
            let ModelID = input.value, retVal = null;
            if (ModelID == "") {
                retVal = { inValidSRC: true };
            }
            if (ModelID && typeof ModelID === 'string') {
                retVal = { inValidSRC: true };
            }
            return retVal;
        }
        this.srclistCtrl = new FormControl('', [
            Validators.required,
            hasSrc.bind(this)
        ]);
        //  this.halistCtrl = new FormControl();
        this.filteredSrc = this.srclistCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterSrc(name) : this.srcList.slice());
    }

    


    ngOnInit(): void {
        let that = this;
        this.loadSrcList();
        this.cashreceipt['oldadvances'] = '';

        this.columns = [
            { name: 'SNo', prop: 'sno', width: 85, minWidth: 85, maxWidth: 85, sortable: false, cellTemplate: this.snoTemplate },
            //{ name: 'Bill No', prop: 'voucher_no', width: 200, minWidth: 200, maxWidth: 200, sortable: false, cellClass: 'cell-left' },
            { name: 'Date', prop: 'trdate', width: 200, minWidth: 200, maxWidth: 200, sortable: false, cellClass: 'cell-left' },
            //{ name: 'Client Name', prop: 'client_name', width: 200, minWidth: 200, maxWidth: 200, sortable: false, cellClass: 'cell-left' },
            { name: 'Bill Amount', prop: 'bill_amount', width: 160, minWidth: 160, maxWidth: 160, sortable: false, cellClass: 'cell-right' },
            { name: 'Remain Amount', prop: 'dramount', width: 160, minWidth: 160, maxWidth: 160, sortable: false, cellClass: 'cell-right' },
      
        ];

        this.filteredItems = this.searchTerms
            .debounceTime(300)        // wait 300ms after each keystroke before considering the term
            .distinctUntilChanged()   // ignore if next search term is same as previous
            .switchMap(term => term   // switch to new observable each time the term changes
                // return the http search observable
                ? this.commonService.loadClientCashReceiptList(term, 'salesBillentry')
                // or the observable of empty heroes if there was no search term
                : Observable.of<any[]>([]))
            //.switchMap(term => this.commonService.loadClientList(term, 'tt'))
            .catch(error => {
                // TODO: add real error handling
                console.log(error);
                return Observable.of<any[]>([]);
            });

        this.filteredItems.subscribe(($e) => {
            that.clientList = $e;
        });

        if (this._params['mode'] == 'Add') {
            this.loadAutoNumber();
            this.minDate = new Date(new Date().getFullYear(),
                new Date().getMonth(),
                new Date().getDate());
            this.cashreceipt['date'] = new Date();
            this.cashreceipt['amount'] = 0;
            this.salesBillgriddata['amount'] = 0;
        } else {
            this.potCusCtrl.disable();
        }

        this.filteredEmp = this.searchTermsEmp
            .debounceTime(300)        // wait 300ms after each keystroke before considering the term
            .distinctUntilChanged()   // ignore if next search term is same as previous
            .switchMap(term => term   // switch to new observable each time the term changes
                // return the http search observable
                ? this.commonService.getEmployeeList(term, 'challan')
                // or the observable of empty heroes if there was no search term
                : Observable.of<EmployeeModel[]>([]))
            //.switchMap(term => this.commonService.getEmployeeList(term, 'tt'))
            .catch(error => {
                // TODO: add real error handling
                console.log(error);
                return Observable.of<EmployeeModel[]>([]);
            });

        this.filteredEmp.subscribe(($e) => {
            that.empList = $e;
        });
        setTimeout(() => {
            $('#type').focus();
        }, 100);

    }
    ///HV SOA SCREEN
    searchEmployee(query: string) {
        this.searchTermsEmp.next(query);
    }
    /*   onSelectedHVClient(clientID: number) {
           // if(_.isEmpty(clientID)){
           //     clientID = this.cashreceipt['client_id'];
           // }
           let that = this,
               //clientID = clientID,
               empid = that.cashreceipt['empid'],
               hclhvlist = _.find(this.clientHVList, { 'client_id': clientID });
           if (!_.isEmpty(hclhvlist)) {
               this.cashreceipt['client_name'] = hclhvlist.client_name;
           }
           let data = {
               empid: empid,
               client_id: clientID
           };
           this.cashReceiptService
               .getChalloutModel(data)
               .then(function(res: any) {
                   if (res.success) {
                       that.haList = res['haStockModel'];
                       that.actSerialNoList = res['haModelStockSerial'];
                       that.halistCtrl.setValue(that.salesBillgriddata['model_id']);
                   }
               });
       }*/
    /*onSelectedEmp(mdCompEvent: any) {
        let that = this,
            empid = mdCompEvent.empid,
            data = {
                empid: empid
            };
        that.cashreceipt['empid'] = empid;

        this.cashReceiptService
            .getExistChalloutClient(data)
            .then(function(res: any) {
                that.clientHVList = res.data;
            });
    }
    displayEmp(empID: number) {
        if (empID && this.empList.length > 0) {
            let femp = _.find(this.empList, { 'empid': empID });
            // this.cashreceipt['emp_name'] = femp.empname;
            return femp['empcode'];
        } else {
            return '';
        }
    }*/
    //HV SOA SCREEN
    /*    loadChallanHaList() {
            let that = this,
                data = {
                    stock_type: 'HA MODEL'
                };
            this.commonService
                .getHaModelStock(data)
                .then(function(res: any) {
                    that.haList = res['haStockModel'];
                    that.actSerialNoList = res['haModelStockSerial'];
                    that.halistCtrl.setValue(that.salesBillgriddata['model_id']);
                });
        }
    
        filterHa(name: string) {
            name = _.escapeRegExp(name);
            return this.haList.filter(ha => (new RegExp(name, 'gi').test(ha.model_id) || new RegExp(name, 'gi').test(ha.name)));
        }
    
        displayHa(model_id: number) {
            this.serialNoList = [];
            if (model_id && this.haList.length > 0) {
                let fhalist = _.find(this.haList, { 'model_id': model_id });
                if (fhalist['stock_type'] == 'Spare') {
                    this.serialNoList.push(fhalist);
                    this.displaySerialNo(fhalist['serial_no']);
                } else {
                    this.getModelSerialNo(model_id); //TO LOAD SERIAL NUMBER FOR THAT MODEL
                }
                return fhalist['name'];
            }
            return '';
        }*/
        loadSrcList () {
        let that = this,
            data = {
                name: ''
            };
        this.commonService
            .getBankLedger(data)
            .then(function (res: any) {
                that.srcList = res['data'];
                // that.actSerialNoList = res['haModelStockSerial'];
                that.srclistCtrl.setValue(that.cashreceipt['bank']);
                //that.srclistCtrl.setValue(that.clientInData['bank_name']);
                //that.emplist2Ctrl.setValue(that.clientFollowDet['empid']);
            });
    }

     filterSrc(bank_name: string) {
        bank_name = _.escapeRegExp(bank_name);
        return this.srcList.filter(ha => (new RegExp(bank_name, 'gi').test(ha.bank)
            || new RegExp(bank_name, 'gi').test(ha.bank_name)));
    }

    displaySrc(item_id: number) {

        if (item_id && this.srcList.length > 0) {
            let fhalist = _.find(this.srcList, { 'bank': item_id }),
                bank_name = fhalist.bank_name;
                this.cashreceipt['bank_name'] = bank_name;
            //this.challangriddata['avail_qty'] = fhalist.avail_qty;
            //  this.getModelSerialNo(item_id);
            return fhalist['bank_name'];
        }
        return '';
    }

    getModelSerialNo(modelID) {
        let actSerialNoList = this.actSerialNoList;
        this.serialNoList = _.filter(actSerialNoList, { 'model_id': modelID });
        this.serialNoCtrl.setValue(this.salesBillgriddata['model_id']);
    }
    filterSerialNo(name: string) {
        name = _.escapeRegExp(name);
        return this.serialNoList.filter(ha => (new RegExp(name, 'gi').test(ha.serial_no)));
    }

    displaySerialNo(serial_no: number) {
        if (serial_no && this.serialNoList.length > 0) {
            let fhalist = _.find(this.serialNoList, { 'serial_no': serial_no }),
                rate = 0,
                mrp = fhalist.model_mrp;
            if (parseFloat(fhalist.mrp) < parseFloat(fhalist.model_mrp)) {
                mrp = fhalist.mrp;
            }
            this.salesBillgriddata['mrp'] = mrp;
            this.salesBillgriddata['challan_out_id'] = fhalist.challan_out_id;
            this.salesBillgriddata['serial_no'] = fhalist.serial_no;
            this.salesBillgriddata['tax_per'] = fhalist.tax_per;
            this.salesBillgriddata['quantity'] = 1;

            if (parseFloat(fhalist.tax_per) > 0) {
                rate = parseFloat(mrp) + (parseFloat(mrp) * parseFloat(fhalist.tax_per)) / 100;
            } else {
                rate = parseFloat(mrp);
            }

            this.salesBillgriddata['rate'] = rate;
            this.calAmount();

            return fhalist['serial_no'];
        }
        return '';
    }

    /* onSelectedHaList(mdCompEvent: any) {
         let model_id = mdCompEvent.option.value,
             fhalist = _.find(this.haList, { 'model_id': model_id });
 
         this.salesBillgriddata['name'] = fhalist.name;
     }*/

    loadAutoNumber(): void {
        let that = this,
            data = {
                account_type: this.cashreceipt['tabParams'],
                date: moment(this.cashreceipt['date']).format('YYYY-MM-DD')
            };
        this.commonService
            .getAutoNumber(data)
            .then(function (res: any) {
                if (res['success']) {
                    that.cashreceipt['auto_no'] = res['auto_no'];
                } else {
                    var toast = {
                        type: 'error',
                        title: 'ERROR',
                        body: 'Oops, Something Went Wrong'
                    };
                    that.toasterService.pop(toast);
                }
            });
    }

    searchClient(query: string) {
        this.searchTerms.next(query);
    }

    setPageData(): void {
        if (this._params != undefined) {
            let mode = this._params['mode'];
            this.cashreceipt = Object.assign({}, this._params);
            if (mode == 'Edit') {
                // this.getCashReceiptDetailList();
                this.cashreceipt['date'] = new Date(this._params['dated']);//new Date();
                this.cashreceipt['hidden_client'] = this._params['client_no']; // FOR AUTO COMPLETE ALTERNATE

            }
        }
    }

    displayFn(client_id: any) {
        if (this.clientList != undefined) {
            if (client_id && this.clientList.length > 0) {
                let fitem = _.find(this.clientList, { 'client_id': client_id });
                this.cashreceipt['client_name'] = fitem.client_name; //ANOTHER FIELD
                this.cashreceipt['ref_name'] = fitem.name;
                this.cashreceipt['genLedid'] = fitem.genLedid; //ANOTHER FIELD
                this.cashreceipt['crm_client_id'] = fitem.crm_client_id;
                return fitem['client_no'];
            }
        }
        return '';
    }
    /* displayHvSoaFn(client_id: any) {
         if (this.clientHVList != undefined) {
             if (client_id && this.clientHVList.length > 0) {
                 let fitem = _.find(this.clientHVList, { 'client_id': client_id });
                 return fitem['client_no'];
             }
         }
         return '';
     }*/
    getCashReceiptDetailList(): void {
        let that = this,
            mode = this._params['mode'],
            bill_type = this.cashreceipt['tabParams'],
            params = {
               // start: `${this.page.offset}`,
               // limit: `${this.page.limit}`,
               // orderColumn: `${this.page.orderBy}`,
                //orderBy: 'bill_id',
               // orderDir: `${this.page.orderDir}`,
               // bill_id: this.cashreceipt['bill_id'],
                client_id: this.cashreceipt['genLedid'],
               // bill_type: bill_type
            };
        this.isLoadMask = this.cashReceiptService
            .getCashReceiptDetailList(params)
            .then(function (res: any) {
                if (res.success) {
                    /*if (bill_type == 'Advance') {
                        if (res.old_advance != 0) {
                            that.subscribeService.subScribeDeleteActiveTab();
                            swal('WARNING', 'Next Advance Entry Found, so you can not Edit this Advance Bill Details', 'warning');
                            return;
                        }
                    }*/
                  //  that.cashreceipt['remain'] = res.amountRes[0].remain;
                  //  that.cashreceipt['remain_amt'] = res.amountRes[0].remain;
                   // that.cashreceipt['totamount'] = res.amountRes[0].totamount;
                    that.page.count = res.totCnt;
                    that.cashReceiptDetails = res.data;
                    if (bill_type == 'Advance' && mode == 'Edit') {
                        that.cashreceipt['oldadvances'] = res.old_advance;
                        that.calGrantTotal('all');
                    }
                }
            });
    }

    onSelectedClient(mdCompEvent: any) {
        let that = this,

            data = {
              //  client_id: mdCompEvent.client_id,
                client_id: mdCompEvent.genLedid
                //client_id: mdCompEvent.genLedid
            };
        this.cashreceipt['genLedid']= mdCompEvent.genLedid ;
        this.cashReceiptService
            .getPendingClient(data)
            .then(function (res: any) {
                //that.clientList = res;
                if (res.totCnt > 0) {
                    swal({
                        title: 'Previous Credit is Still Pending,you want to Continue?',
                        //  text: 'Credit Amount: ' + res.data[0].amount,
                        showCancelButton: true,
                        confirmButtonText: 'Yes, Continue!',
                        cancelButtonText: 'No, Cancel'
                    }).then(function () {
                        that.cashreceipt['adv_bill_id'] = res.data[0].adv_bill_id;
                        //that.cashreceipt['bill_type'] = res.data[0].bill_type;
                        that.cashreceipt['bill_id'] = res.data[0].adv_bill_id;
                        // that.cashreceipt['remain'] = res.data[0].remain;
                        //  that.cashreceipt['totamount'] = res.data[0].totamount;
                        that.cashreceipt['discount_percentage'] = res.data[0].discount_percentage;
                        that.cashreceipt['discount_amount'] = res.data[0].discount_amount;
                        that.cashreceipt['oldadvances'] = res.data[0].oldadvances;
                        //that.cashreceipt['amount'] = res.data[0].amount;
                        if (that.cashreceipt['tabParams'] != "Advance") {
                            that.cashreceipt['advances'] = res.data[0].oldadvances;
                        }
                        that.getCashReceiptDetailList();
                        that.calGrantTotal('all');
                        that.cashreceipt['hide_col'] = true;
                    }, function (dismiss) {
                        if (that.cashreceipt['tabParams'] == 'Advance') {
                            that.cashreceipt['client_name'] = '';
                            that.cashreceipt['client_id'] = '';
                        }
                    });
                }
            });
    }

    onEnterKeyPressed(nextEl: string): void {
        if (_.isEmpty(document.getElementById(nextEl))) {
            nextEl = 'empid';
        }
        $('#' + nextEl).focus();
    }

    calAmount() {
        let grs = this.cashreceipt['gross_total'],
            grand = this.cashreceipt['grand_total'],
            amt = this.cashreceipt['amount'],
            totamount = this.cashreceipt['totamount'],
            remain = this.cashreceipt['remain'],
            remain_amt = this.cashreceipt['remain_amt'];

        amt = (amt == "") ? 0 : amt;

        if (!_.isEmpty(_.toString(amt))) {
            grs = amt;
        } else {
            grs = '';
        }
        if (!_.isEmpty(_.toString(amt))) {
            grand = amt;
        } else {
            grand = '';
        }
        if(amt==null){
                amt = 0;
         }
        if (!_.isEmpty(_.toString(amt))) {
            remain = ((remain_amt) - parseFloat(amt));
        }

        this.cashreceipt['amount'] = amt;
        this.cashreceipt['gross_total'] = grs;
        this.cashreceipt['grand_total'] = grand;
        if (!isNaN(remain))
            this.cashreceipt['remain'] = remain;
    }

    calGrantTotal(from_field) {

        let gross_total = this.cashreceipt['gross_total'],
            dis_per = this.cashreceipt['discount_percentage'],
            discount_amount = this.cashreceipt['discount_amount'],
            grant_total = 0;


        if (_.isEmpty(_.toString(gross_total))) {
            gross_total = 0;
        }
        if (!_.isEmpty(_.toString(dis_per))) {
            if (dis_per >= 0 && from_field == 'dis_per') {
                this.cashreceipt['discount_amount'] = 0;
                discount_amount = (gross_total * dis_per) / 100;

            }
        } else {
            dis_per = 0;
            discount_amount = 0;
        }
        if (!_.isEmpty(_.toString(discount_amount)) && discount_amount != 0) {
            if (from_field == 'dis_amt')
                this.cashreceipt['discount_percentage'] = 0;//(parseFloat(discount_amount) / parseFloat(gross_total)) * 100;
            dis_per = (discount_amount / gross_total) * 100;
            dis_per = (dis_per.toFixed(2)) / 1;

        } else {
            discount_amount = 0;
            dis_per = 0;
        }

        grant_total = (parseFloat(gross_total) - (discount_amount));

        this.cashreceipt['discount_percentage'] = dis_per;
        this.cashreceipt['discount_amount'] = discount_amount;
        this.cashreceipt['grand_total'] = grant_total;
    }
    bsModalRef: BsModalRef;
    onSaveSalesbillentry(): void {
        let that = this,
            mode = this.cashreceipt['mode'];

        if (_.isEmpty(_.toString(this.cashreceipt['type']))) {
            swal('WARNING', 'Please Select Type');
            return;
        }
        if (_.isEmpty(_.toString(this.cashreceipt['client_id']))) {
            swal('WARNING', 'Please Select Client ID');
            return;
        }
        if (_.isEmpty(_.toString(this.cashreceipt['description']))) {
            swal('WARNING', 'Please Type Description');
            return;
        }


        let salesBillentryDate = moment(this.cashreceipt['date']).format('YYYY-MM-DD'),
            data = {
                bill_id: this.cashreceipt['bill_id'],
                auto_no: this.cashreceipt['auto_no'],
                date: salesBillentryDate,
                type: this.cashreceipt['type'],
                client_id: this.cashreceipt['crm_client_id'],
                genLedid: this.cashreceipt['genLedid'],
                client_name: this.cashreceipt['client_name'],
                gross_total: this.cashreceipt['gross_total'],
                discount_percentage: this.cashreceipt['discount_percentage'],
                discount_amount: this.cashreceipt['discount_amount'],
                grand_total: this.cashreceipt['grand_total'],
                description: this.cashreceipt['description'],
                mode: this.cashreceipt['mode'],
                bill_type: this.cashreceipt['tabParams'],
                chqno: this.cashreceipt['chqno'],
                bank: this.cashreceipt['bank']
            };


        that.isLoading = true;
        this.cashReceiptService
            .addCashReceiptentry(data)
            .then(function (res: any) {
                that.isLoading = false;
                if (res.success) {
                    that.cashreceipt = [];
                    that.cashReceiptDetails = [];
                    swal('SUCCESS', res.message, 'success');
                    that.subscribeService.subScribeDeleteActiveTab();
                    that.subscribeService.subReloadSalesBillentryListGrid();
                } else {
                    swal('ERROR', res.message, 'error');
                }
            })
            .catch(function (error: any) {
                that.isLoading = false;
                let res = JSON.parse(error._body);
                swal('ERROR', res.message, 'error');
                //console.log(error);
            });
    }

}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/transaction/cashReceipt/addEditCashReceipt.component.ts